import React from "react";
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Card, Col, Row, Typography } from 'antd';
import { mostUsedPages } from '../pageUsage';
import { groupOfPage, NAV_GROUPS } from '../navbar/navItems';

const { Title, Text } = Typography;

const groupLabel = (pageKey) => NAV_GROUPS.find((g) => g.key === groupOfPage(pageKey))?.label;

export const Dashboard = inject('currentUserStore')(observer(({ currentUserStore }) => {
    const name = currentUserStore.user?.displayName || currentUserStore.user?.email || 'Admin';
    const mostUsed = mostUsedPages(currentUserStore.user?.uid).filter(({ page }) => !page.scope || currentUserStore.can(page.scope, page.ownership));
    return (
        <div style={{ padding: 32 }}>
            <Title level={2}>Welcome, {name}</Title>
            <Text type="secondary">Use the navigation on the left to manage the platform.</Text>
            <Title level={4} style={{ marginTop: 32 }}>Your most used pages</Title>
            {mostUsed.length === 0 ? (
                <Text type="secondary">The pages you open most will show up here.</Text>
            ) : (
                <Row gutter={[16, 16]}>
                    {mostUsed.map(({ page, count }) => (
                        <Col key={page.key} xs={24} sm={12} lg={8} xl={6}>
                            <Link to={page.key}>
                                <Card size="small" hoverable>
                                    <Text type="secondary" style={{ fontSize: 12 }}>{groupLabel(page.key)}</Text>
                                    <div style={{ fontSize: 16, fontWeight: 500 }}>{page.label}</div>
                                    <Text type="secondary" style={{ fontSize: 12 }}>Opened {count} time{count === 1 ? '' : 's'}</Text>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    );
}));
